import React from "react";

const Footer: React.FC = () => (
  <footer>
    <div className="container">
      <div className="row">
        <div className="col-6">
          <span>
            © <span id="year">2019</span> «Цезарь Сателлит» — Все права
            защищены.
          </span>
        </div>
        <div className="col-6 tar">
          <a href="http://csat.ru" id="site">
            CSAT.RU
          </a>
          <a href="tel:+79163450197" id="phone">
            +7 (916) 345-01-97
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
